/**
 * 国际化工具类.
 * 为了和旧的Jarvis保持一致, 做如下规范:
 * zh-CN => zh_CN
 * en-US => en_US
 */
import { getCookie, setCookie } from './LibsCookieUtils';

type SupportLocale = 'zh_CN' | 'en_US';

export const KEY_LANG_COOKIE = '_JARVIS.LOCALE_';

const KEY_LANG_COOKIE_AP = '_AP.JARVIS.LOCALE_';
const KEY_LANG_COOKIE_EU = '_EU.JARVIS.LOCALE_';
const KEY_LANG_COOKIE_NA = '_NA.JARVIS.LOCALE_';
const KEY_CURRENT_LANGUAGE = 'CurrentLanguage';
const KEY_LOCALE_LANG = 'LOCALE_LANG';
const KEY_LANG_LC = 'amis-locale';

/** */
const getLang: any = () =>
	// 默认英文
	'en';

// if (navigator.languages?.length) {
// 	return navigator.languages[0];
// }

// return (navigator as any).userLanguage || navigator.language || (navigator as any).browserLanguage || 'en';
/** */
const getLocaleFromLang: any = (defaultLocale = 'en_US') => {
	const lang = getLang();
	if (!lang) {
		return '';
	}

	if (lang.startsWith('zh')) {
		return 'zh_CN';
	}

	if (lang.startsWith('en')) {
		return 'en_US';
	}

	return defaultLocale;
};

/**
 * 获取cookie或者lc中的语言设置
 * 注意, 旧页面里的zh-CN被写成了'zh_CN', 需要矫正
 */
const getLocaleFromStorage: any = () => {
	const cookieLang = getCookie(KEY_LANG_COOKIE);
	const lcLang = localStorage.getItem(KEY_LANG_LC);
	if (cookieLang && lcLang !== cookieLang) {
		localStorage.setItem(KEY_LANG_LC, cookieLang);
	}

	return cookieLang || lcLang || '';
};

const CURR_LOCALE = (() => getLocaleFromStorage() || localStorage.getItem(KEY_LANG_LC) || getLocaleFromLang() || 'en_US')() as SupportLocale;

/** 获取当前的国际化设置 */
export const getJarvisLocale: any = () => {
	const currLocale = CURR_LOCALE && CURR_LOCALE.indexOf('-') !== -1 ? CURR_LOCALE.replace('-', '_') : CURR_LOCALE;
	if (currLocale !== 'en_US' && currLocale !== 'zh_CN') {
		return 'en_US';
	}

	return currLocale;
};

/** 设置国际化 */
export const setJarvisLocale: any = (locale: SupportLocale) => {
	localStorage.setItem(KEY_LANG_LC, locale);
	const hostName = location.hostname;
	let domain = '';
	if (hostName !== 'localhost') {
		const hosts = location.hostname.split('.');
		domain = `.${hosts.slice(hosts.length - 2).join('.')}`;
	} else {
		domain = hostName;
	}

	// 改成旧的格式
	setCookie(KEY_LANG_COOKIE, locale, domain);
	// setCookie(KEY_LANG_COOKIE_AP, locale, domain);
	// setCookie(KEY_LANG_COOKIE_EU, locale, domain);
	// setCookie(KEY_LANG_COOKIE_NA, locale, domain);
	// setCookie(KEY_LOCALE_LANG, locale, domain);

	// currentLanguage
	// const lang = locale === 'en_US' ? 'en' : 'zhCHS';
	// setCookie(KEY_CURRENT_LANGUAGE, lang, domain);
};

/** 非生产环境标识列表 */
const NON_PRODUCTION_LIST = ['dev-', 'test-', 'uat-', 'localhost', 'dev.'];

/** 判断当前是否为生产环境 */
export const isProductionEnv = (): boolean => {
	const host = window.location.host;
	return !NON_PRODUCTION_LIST.some((x: string) => host.includes(x));
};

/** 获取注册页面URL（根据环境自动判断） */
export const getRegisterUrl = (): string => {
	return isProductionEnv()
		? 'http://ap-sms-bidding.tencent.com/register/vendorSwitch'
		: 'http://test-ap-sms-bidding.tencent.com/register/vendorSwitch';
};

/** 跳转到注册页面 */
export const goToRegister = (): void => {
	window.location.replace(getRegisterUrl());
};

/** 跳转 */
export const goLink: any = (link: string, disabled: boolean = false, lang: string = '', withLang: boolean = false) => {
	if (disabled || !link) {
		return;
	}

	let finalLink = link;
	const hasParams = link.indexOf('?') > -1;
	if (hasParams) {
		finalLink = `${link}&fromPortal=true`;
	} else {
		finalLink = `${link}?fromPortal=true`;
	}

	if (lang && withLang) {
		const l = lang === 'en' ? 'en' : 'zhCHS';
		finalLink = `${finalLink}&language=${lang}&lang=${l}`;
	}

	// window.open(this.getLink(no, type));
	window.open(finalLink, '_blank');
};
